/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import request from '@/utils/http';
// 查询列表
export const getSourceRoot = (params) => {
    return request({
        url: `/api-tms/transport/grouppolicy/list2`,
        method: 'post',
        data: params
    }).then(res => res);
};
export const getSourceData = (params) => {
    return request({
        url: `/api-tms/transport/list/bygrouppolicy`,
        method: 'post',
        data: params
    }).then(res => res);
};
export const getDictList = (params) => {
    return request({
        url: `/api-mdm/dictionaryDetail/dict`,
        method: 'get',
        params
    });
};
export const getTargetRoot = (data) => {
    return request({
        url: `/api-tms/dispatch/list`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTargetData = (data) => {
    return request({
        url: `/api-tms/transport/list/sort`,
        method: 'post',
        data
    }).then(res => res);
};
export const getDetailStatistics = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail/count`,
        method: 'post',
        data
    }).then(res => res);
};
export const getStorageData = (params) => {
    return request({
        url: `/api-tms/dispatch/distribution/search`,
        method: 'get',
        params
    }).then(res => res);
};
export const getAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/update/${data.taskNo}`,
        method: 'put',
        data
    }).then(res => res);
};
export const getCancleAllocate = (data) => {
    return request({
        url: `/api-tms/dispatch/distribution/cancel`,
        method: 'put',
        data
    }).then(res => res);
};
export const saveCarArrange = (data) => {
    return request({
        url: `/api-tms/dispatch/artificial/save`,
        method: 'post',
        data
    }).then(res => res);
};
export const intelligentDispatch = (data) => {
    return request({
        url: `/api-tms/dispatch/intelligent`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateCarArrange = (data) => {
    return request({
        url: `/api-tms/transport/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const updateIntelliArrange = (data) => {
    return request({
        url: `/api-tms/intelligent/operate`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTransferData = (data) => {
    return request({
        url: `/api-tms/transport/transfer`,
        method: 'post',
        data
    }).then(res => res);
};
export const getTabelExpandDetail = (data) => {
    return request({
        url: `/api-tms/transport/itemdeail`,
        method: 'post',
        data
    }).then(res => res);
};
export const issueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/issueCarrier`,
        method: 'put',
        data
    });
};
export const confirmIssueCarrier = (data) => {
    return request({
        url: `/api-tms/transport/confirmIssueCarrier`,
        method: 'put',
        data
    });
};
// 修改配送方式页面获取网点信息
export const searchNetInfo = (data) => {
    return request({
        url: `/api-tms/transports/searchNetinfo`,
        method: 'post',
        data
    }).then(res => res);
};
// 修改配送方式
export const updateDeliveryMethods = (data) => {
    return request({
        url: `/api-tms/transport/distributionModeUpdate`,
        method: 'post',
        data
    }).then(res => res);
};
// 查询网点信息
export const netInfos = (params) => {
    return request({
        url: `/api-mdm/netInfos`,
        method: 'get',
        params
    });
};
export const appointment = (data) => {
    return request({
        url: `/api-tms/transports/appointment`,
        method: 'put',
        data
    });
};
// 苏宁排车前检验
export const dispatchVerifyApi = (data) => {
    return request({
        url: '/api-tms/dispatch/save/verify',
        method: 'post',
        data
    });
};
// 苏宁加减单检验
export const addOfReduceVerifyApi = (data) => {
    return request({
        url: '/api-tms/transport/operate/verify',
        method: 'post',
        data
    });
};
// 整车排车时提示在途跟踪方式
export const promptTrackType = (data) => {
    return request({
        url: `/api-tms/dispatch/promptTrackType?dispatchNo=${data}`,
        method: 'post'
    });
};
// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
// 获取ts订单
export const getTsOrdersApi = (data) => {
    return request({
        url: `/api-tms/transport/tsOrder/check`,
        method: 'post',
        data
    });
};
// 正逆向订单提示
export const pullDownTipsApi = (data) => {
    return request({
        url: `/api-tms/transportExtend/pullDownTips`,
        method: 'post',
        data
    });
};
// 加单提示
export const pullDownOrderCheckTipsApi = (data) => {
    return request({
        url: `/api-tms/dispatch/customer/order/check`,
        method: 'post',
        data
    });
};
export const getTasksByTaskNosApi = (data) => {
    return request({
        url: `/api-tms/transportSameCompleteSetNo`,
        method: 'post',
        data
    });
};
// 取消时效优先标识
export const cancelTimePriorityTagApi = (data) => {
    return request({
        url: `/api-tms//transport/cancelTimePriorityTag`,
        method: 'post',
        data
    });
};
